import React, { useState, useEffect } from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import 'react-material-symbols/rounded';
import AxiosClient from '../../assets/AxiosClient';
import wordsToRemove from './assets/wordsToRemove'; 
import wordsToReplace from './assets/wordsToReplace';
import AName from './A_Name';
import { DataTable, PageHeader } from '../../componants/Workspace';

const standardizeName = (name) => {
  let standardized = name.trim().toLowerCase(); // Convert to lowercase and remove leading/trailing spaces

  wordsToRemove.forEach(word => {
    standardized = standardized.replace(word, ''); // Remove the word
  });

  Object.keys(wordsToReplace).forEach(word => {
    const replacement = wordsToReplace[word];
    standardized = standardized.replace(new RegExp('\\b' + word + '\\b', 'gi'), replacement);
  });

  standardized = standardized.split(' ').map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');

  return standardized;
};

const NamesProcess = () => {
  const [Attendants, setAttendants] = useState([]);
  const [updatedIndexes, setUpdatedIndexes] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (Attendants.length === 0) {
      GetAttend();
    }
  }, []);

  const GetAttend = () => {
    AxiosClient.get('ETL/Attends').then((response) => {
      setAttendants(response.data);
    });
  };

  const Transfair = () => {
    setAttendants(Attendants.map(attendant => ({
      ...attendant,
      first_name: standardizeName(attendant.first_name),
      last_name: standardizeName(attendant.last_name),
      middle_name: standardizeName(attendant.middle_name)
    })));
  };

  const Load = () => {
    const updatedIndexes = [];
    Attendants.forEach((attendant, index) => {
      AxiosClient.put(`ETL/updateAttends/${attendant.id}`, {
        first_name: standardizeName(attendant.first_name),
        last_name: standardizeName(attendant.last_name),
        middle_name: standardizeName(attendant.middle_name)
      }).then(response => {
        updatedIndexes.push(index);
        setUpdatedIndexes(updatedIndexes);
        const newProgress = ((updatedIndexes.length / Attendants.length) * 100).toFixed(2);
        setProgress(newProgress);
        // Handle success
      }).catch(error => {
        console.error('Error updating attendee:', error);
      });
    });
  };

  const ShowNames = () => {
    // Implement the logic to show the names
    // You can access the names in the `Attendants` state
    // and display them in the table
  };

  return (
    <>
      <PageHeader
        title="Name normalization"
        description="Standardize attendee names before loading updates."
        actions={(
          Attendants.length === 0 ? (
            <button className="btn btn-primary" onClick={GetAttend} type="button">
              <MaterialSymbol icon="database" size={18} />
              Extract records
            </button>
          ) : (
            <>
              <button className="btn btn-outline-secondary" onClick={ShowNames} type="button">
                <MaterialSymbol icon="visibility" size={18} />Show
              </button>
              <button className="btn btn-outline-secondary" onClick={Transfair} type="button">
                <MaterialSymbol icon="auto_fix_high" size={18} />Transform
              </button>
              <button className="btn btn-primary" onClick={Load} type="button">
                <MaterialSymbol icon="cloud_upload" size={18} />Load changes
              </button>
            </>
          )
        )}
      />

      {Attendants.length > 0 && (
        <>
          <div className="workspace-progress">
            <span>Updated {updatedIndexes.length} of {Attendants.length}</span>
            <div className="progress" role="progressbar" aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100" aria-label="Name update progress">
              <div className="progress-bar" style={{ width: `${progress}%` }}>{progress}%</div>
            </div>
          </div>
          <DataTable>
            <thead>
              <tr>
                <th>First name</th>
                <th>Middle name</th>
                <th>Last name</th>
              </tr>
            </thead>
            <tbody>
              {Attendants.map((attendant, index) => (
                <tr key={attendant.id} className={updatedIndexes.includes(index) ? 'table-success' : ''}>
                  <td><AName name={attendant.first_name} /></td>
                  <td><AName name={attendant.middle_name} /></td>
                  <td><AName name={attendant.last_name} /></td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </>
      )}
    </>
  );
};

export default NamesProcess;
